import styled from 'styled-components';
import { iconStyling } from '../../commonStyles/accordionSection';
import colors from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { PrimaryCta } from '../Cta';
import { IconWrapper as CtaIconWrapper } from '../Cta/styles';
import { GridItem } from '../Grid';
import Icon from '../Icon';
import { ButtonLink } from '../Link';
import { CloseButton, CloseButtonText } from '../Modal/styles';
import RichText from '../RichText';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    margin-bottom: 0;  
  `}
`;

export const AlertBannerCloseButton = styled(CloseButton)`
  margin-right: 0;
`;

export const AlertBannerCloseText = styled(CloseButtonText)`
  color: ${colors.neutral01};
  font-weight: 400;
`;

export const AlertBannerContainer = styled.div<{ emergencyVariant: boolean }>`
  padding: ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    padding: ${spacing(2)} ${spacing(2)} ${spacing(4)} ${spacing(4)};
  `}

  background-color: ${({ emergencyVariant }) =>
    emergencyVariant ? colors.notificationWarningLight : colors.neutral07};

  border: 2px solid
    ${({ emergencyVariant }) =>
      emergencyVariant ? colors.selectorHighlight : colors.neutral01};
  border-left-width: ${spacing(2)};
`;

export const HeadingGridItem = styled(GridItem)<{
  closable: boolean;
  collapsible: boolean;
}>`
  display: flex;
  align-items: center;
  padding-top: ${({ closable, collapsible }) =>
    closable || collapsible ? 0 : spacing(2)};
`;

export const AlertBannerHeading = styled.h2`
  ${fonts.headingSmall};
  margin: 0;
`;

export const IconWrapper = styled.div`
  margin-right: ${spacing(2)};
`;

export const StyledRichText = styled(RichText)<{ emergencyVariant: boolean }>`
  margin-top: ${spacing(2)};

  ul {
    padding: 0;

    > li::before {
      background-color: ${colors.neutral01};
    }
  }

  a {
    margin-top: ${spacing(-1)};

    :link {
      color: ${colors.neutral01};
    }

    :visited {
      color: #660199;
    }

    &:hover {
      text-decoration: none;
    }

    &:focus,
    &:active {
      color: ${colors.neutral02};
      box-shadow: 0 0 0 4px
          ${({ emergencyVariant }) =>
            emergencyVariant ? colors.notificationWarningLight : colors.neutral07},
        0 0 0 6px ${colors.core02};
    }
  }
`;

export const AlertBannerCta = styled(PrimaryCta)<{
  emergencyVariant: boolean;
}>`
  background-color: ${colors.neutral08};
  color: ${colors.neutral01};
  font-weight: 400;
  border-color: ${colors.neutral01};

  margin-top: ${spacing(4)};

  &:hover {
    box-shadow: none;
  }

  &:hover,
  &:focus {
    transition: 0s;
    border: 2px solid ${colors.neutral02};
    background-color: ${colors.neutral08};

    ${CtaIconWrapper} {
      color: ${colors.neutral02};
    }
  }

  &:active {
    border: 2px solid ${colors.neutral02};
    background-color: ${colors.neutral02};
    color: ${colors.neutral08};

    ${CtaIconWrapper} {
      color: ${colors.neutral08};
    }
  }

  &:focus,
  &:active {
    box-shadow: 0 0 0 4px
        ${({ emergencyVariant }) =>
          emergencyVariant ? colors.notificationWarningLight : colors.neutral07},
      0 0 0 6px ${colors.core02};
  }
`;

export const HelpButton = styled(ButtonLink)`
  ${fonts.paragraph}
  & {
    font-weight: normal;
  }
  vertical-align: middle;
  display: inline;
`;

export const StyledIcon = styled(Icon)`
  ${iconStyling}
`;

export const MultiBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`;
